<template>
  <el-form-item v-if="platoons && platoons.length > 0" label="Platoon" prop="platoon_id">
    <el-select-v2 v-model="platoonId" placeholder="Select Platoon" :options="platoons" style="width: 100%"
      @change="$emit('selected-platoon-id', platoonId)" />
  </el-form-item>
</template>

<script>
import { ref, watch } from "vue";
import store from "@/store";
import Constants from "@/helpers/constants";

export default {
  name: "PlatoonDropdownV2",
  props: {
    allowAll: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Number,
      default: -1,
    },
  },
  emits: ["selected-platoon-id"],
  setup(props) {
    let platoonId = ref(props.selected);
    if (platoonId.value == -1 && !props.allowAll) {
      platoonId.value = "";
    }

    watch(
      () => props.selected,
      (current) => {
        if (current == -1 && !props.allowAll) platoonId.value = "";
        else platoonId.value = current;
      }
    );
    return { platoonId };
  },
  data() {
    return {
      platoons: [],
      usrMngrrstrtdPltns: ['ADCDA', 'CDA'],
    };
  },
  created() {
    let loggedInUser = this.$store.getters["auth/getLoggedInUser"]();
    let platoonId = -1;
    if(loggedInUser.role && loggedInUser.role.role_id == Constants.ROLES.PLATOON_COMMANDER) {
      platoonId = loggedInUser.platoon_id;
    }
    store
      .dispatch("list/getPlatoons", { sort: "name", order: "asc", platoon_id: platoonId })
      .then((res) => {
        let platoonList = [];
        if (res.data && res.data.length > 0) {
          for (let data of res.data) {
            if(loggedInUser.role.role_id == Constants.ROLES.USER_MANAGER && this.usrMngrrstrtdPltns.includes(data.name)) {
              continue; // Skip if user manager
            }
            platoonList.push({ value: data.platoon_id, label: data.name })
          }
        }
        this.platoons = platoonList;
        if (this.allowAll && loggedInUser.role.role_id != Constants.ROLES.USER_MANAGER) {
          this.platoons.unshift({ value: -1, label: "All Platoons" });
        }
      });
  },
};
</script>

<style></style>